import { useState, useEffect, useRef } from "react";
import { Card, Row, Col } from 'react-bootstrap';
import "./Invoice.scss"
import Grid, { GridColumn, GridHeader, GridRow } from "../Grid/Grid";
import HelperService from "../utility/HelperService";
import Loader from "../Loader/Loader";
import { Button } from "../Button/Button";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import WebService from "../utility/WebService";
import { Label } from "../Label/Label";
import { PlusSquare } from "react-bootstrap-icons";
import { toast } from "react-toastify";

interface propData {
    data: any;
    code: string;
    payment?: boolean;
    refreshTrigger: boolean; 
}

const InvoiceDetailPaymentList = (props: propData) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const value = encodeURIComponent(urlParams.get('amount') || "")
    const componentKey = "AssociatDepo";
    const headers: GridHeader[] = [
        {
            title: "Auth Code",
            class: "text-center",
        },
        {
            title: "Payment Date",
            class: "text-center",
        },
        {
            title: "Payment Time",
            class: "text-center",
        },
        {
            title: "Amount",
            class: "text-center",
        },
        {
            title: "Comments",
            class: "text-center",
        },

    ];
    const [isLoading, setLoading] = useState(false);
    const [downPayment, setDownPayment] = useState(0);
    const [rows, setRows] = useState<GridRow[]>([]);
    const [show, setShow] = useState(false);
    const [savedCardsData, setSavedCardsData] = useState<any[]>([])
    const [selectedCard, setSelectedCard] = useState<any>()
    const [finalAmount, setFinalAmount] = useState<any>()
    const [authKeyData, setAuthKeyData] = useState<any>()
    const [isPaymentDone, setIsPaymentDone] = useState(false)
    const[isAmtEditable, setIsAmtEditable] = useState(false)
    const paymentResponse = useRef<any>()
    const [invoiceData, setInvoiceData] = useState<any>()
    const [feeData, setFeeData] = useState<any>()
    var total_amount = 0
    if (feeData?.transactionFeeEnabled) {
        if (!feeData?.checkSalesAmtMin || feeData?.checkSalesAmtMin && Number(finalAmount) > Number(feeData?.salesAmountLowerCeiling)) {
            total_amount = Number(((feeData?.transactionFeePerc / 100) * finalAmount).toFixed(2))
        }
    }
    const handleClose = () => setShow(false);

    useEffect(() => {
       fetchPaymentData();
    }, [props?.data?.payments,props?.data?.invoiceData])

      // Fetch on mount AND whenever refreshTrigger changes
    useEffect(() => {
        getPaymentData();
        fetchPaymentData();
    }, [props.refreshTrigger, props?.data]); // refresh on trigger

    const fetchPaymentData = () =>{ 
         const depositRef = props?.data?.callInfo?.depositRef;
         const refNum1 = props?.data?.callInfo?.paymentRefNum1;
         const refNum2 = props?.data?.callInfo?.paymentRefNum2;
         const effectivePmt1 = refNum1 ? Number(props?.data?.callInfo?.paymentAmt1) : 0;
         const effectivePmt2 = refNum2 ? Number(props?.data?.callInfo?.paymentAmt2) : 0;
         const effectiveDeposit = (depositRef && (depositRef === refNum1 || depositRef === refNum2)) ? 0 : Number(props?.data?.callInfo?.depositAmt);
         var value = (Number(props?.data?.callInfo?.invTotalAmt) - (effectiveDeposit + effectivePmt1 + effectivePmt2))
          if(Number(value) <=0 ) value = 0;
       if(props.refreshTrigger) setDownPayment(value);
        if(effectivePmt1 <=0 ) setIsAmtEditable(true);
        if (props?.data?.payments.length > 0) {
            let rows: GridRow[] = [];
            for (var i in props?.data?.payments) {
                let columns: GridColumn[] = [];
                columns.push({ value: props.data.payments[i].authCode });
                columns.push({ value: props.data.payments[i].processingDateTimeUTC && moment(props.data.payments[i].processingDateTimeUT).format('MM/DD/YY') });
                columns.push({ value: props.data.payments[i].processingDateTimeUTC && moment(props.data.payments[i].processingDateTimeUT).format('hh:mm A') });
                columns.push({ value: props.data.payments[i].amount && HelperService.getCurrencyFormatter(props.data.payments[i].amount) });
                columns.push({ value: props.data.payments[i].comments ? props.data.payments[i].comments : '-' });
                rows.push({ data: columns });
            }
            setRows(rows);
        }
        // getSavedCards()
        setInvoiceData(props?.data?.callInfo)
        if (props.payment && value) {
            getAuthorizationKey()
        }
    }

    const getFees = () => {
        WebService.getAPI({
            action: `api/CreditCard/getProgramFeesInfo?CompanyCode=113&TechNum=105`
        })
            .then((res: any) => {
                setFeeData(res.data)
            })
            .catch((e) => {

            })
    }

    const getSavedCards = () => {
        WebService.getAPI({
            action: `api/CreditCard/getSavedCreditCards?CompanyCode=${props?.code}&BillTo=${props?.data?.billTo?.billTo}`
        })
            .then((res: any) => {
                setSavedCardsData(res.data)
                if (res.data.length == 0) {
                    setSelectedCard('NEW_CARD')
                } else {
                    setSelectedCard(res?.data[0]?.sequence)
                }
            })
            .catch((e) => {

            })
    }

    const getPaymentData = () => {
        setLoading(true)
        WebService.getAPI({
            action: `api/Invoice/customerInvoicePayments?CompanyCode=${props?.code}&InvoiceNumber=${props?.data?.callInfo?.invoiceNum}`
        })
            .then((res: any) => {
                setInvoiceData(res.data)
                const depositRef = res?.data?.depositRef;
                const refNum1 = res?.data?.paymentRefNum1;
                const refNum2 = res?.data?.paymentRefNum2;
                const effectivePmt1 = refNum1 ? Number(res?.data?.paymentAmt1) : 0;
                const effectivePmt2 = refNum2 ? Number(res?.data?.paymentAmt2) : 0;
                const effectiveDeposit = (depositRef && (depositRef === refNum1 || depositRef === refNum2)) ? 0 : Number(res?.data?.depositAmt);
                var value = (Number(res?.data?.invTotalAmt) - (effectiveDeposit + effectivePmt1 + effectivePmt2))
                if(Number(value) <=0 ) value = 0;
                setDownPayment(value)
                if(effectivePmt1 <=0 ) setIsAmtEditable(true);
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
            })
    }


    var data: any = {
        "authenticationKey": authKeyData?.authenticationKey,// should get from server
        "operationType": "HostedPaymentsAccountId",
        "paymentSourceType": "Card",
        "cardEntryContext": "WebConsumerInitiated",
        "achAuthorizationType": "Web",
        "nameOnAccountField": "NameOnAccount",
        "zipField": "Zip",
        "showNameOnAccount": true,
        "showZip": true,
        "formId": "tokenForm",
        "completionCallback": "",
        "hostedPaymentURL": authKeyData?.hostedPaymentURL
    };

    const openModal = () => {
        if (authKeyData?.authenticationKey) {
            const channel = new BroadcastChannel("OPEN_HOSTED_PAYMENT");
            if (props.payment && value) {
                data.total_amount = Number(value).toFixed(2)
            } else {
                data.total_amount = (finalAmount + total_amount).toFixed(2)
            }
            channel.postMessage(data);
        }
    };


    const channel = new BroadcastChannel("OPEN_HOSTED_PAYMENT_CALLBACK");
    channel.onmessage = (event) => {
        if (event?.data) {
            setIsPaymentDone(true)
            paymentResponse.current = event.data
        }
        if (event?.data?.gatewayResponse) {

        }
    };

    const addNewCard = (data: any) => {
        setLoading(true)
        var value = data && JSON.parse(data)
        WebService.postAPI({
            action: `api/CreditCard/ChargeWithTokenMultipleInvoicesNewCard`,
            body: {
                CompanyCode: props.code,
                NewCardToken: value?.gatewayResponse?.hostedPaymentsAccountId,
                NewCardName: 'test',
                NewCardLast4: value?.requestDetails?.cardNumber,
                BillTo: props?.data?.billTo?.billTo,
                AmountToCharge: finalAmount,
                UserNumber: '',
                UserName: 'CUSTOMER',
                UserType: 'C',
                TransactionFee: 0,
                sendReceiptToEmail: '',
                sendReceiptToPhone: '',
                Comments: '',
                Invoices: [
                    {
                        Module: 'SD',
                        InvoiceNum: props?.data?.callInfo?.invoiceNum.toString(),
                        Amount: finalAmount
                    }
                ]
            }
        })
            .then((res: any) => {
                setLoading(false)
                if (res.success == true) {
                    // setIsPaymentDone(false)
                    toast.success('Payment done successfully')
                    getPaymentData()
                } else {
                    toast.error(res?.errorInfo?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                toast.error(e?.response?.data?.errorInfo?.message)
                paymentResponse.current = null;
                // setIsPaymentDone(false)
            })
    }

    const onMakePayment = () => {
        var total_amount = Number(finalAmount)
        if (feeData?.transactionFeeEnabled) {
            if (!feeData?.checkSalesAmtMin || feeData?.checkSalesAmtMin && Number(finalAmount) > Number(feeData?.salesAmountLowerCeiling)) {
                var value = ((feeData?.transactionFeePerc / 100) * finalAmount).toFixed(2)
                total_amount += Number(value)
            }
        }
        setLoading(true)
        WebService.postAPI({
            action: `api/CreditCard/ChargeWithTokenMultipleInvoices`,
            body: {
                CompanyCode: props.code,
                Sequence: selectedCard,
                BillTo: props?.data?.billTo?.billTo,
                AmountToCharge: total_amount,
                UserNumber: '',
                UserName: 'CUSTOMER',
                UserType: 'C',
                TransactionFee: 0,
                Comments: '',
                Invoices: [
                    {
                        Module: 'SD',
                        InvoiceNum: props?.data?.callInfo?.invoiceNum.toString(),
                        Amount: Number(finalAmount)
                    }
                ]
            }
        })
            .then((res: any) => {
                setLoading(false)
                if (res.success == true && res.data.status == 'Approved') {
                    toast.success('Payment done successfully')
                    getPaymentData()
                } else {
                    toast.error(res?.errorInfo?.message)
                }
            })
            .catch((e) => {
                setLoading(false)
                toast.error(e?.response?.data?.errorInfo?.message)
            })
    }

    const getAuthorizationKey = () => {
        setLoading(true)
        WebService.postAPI({
            action: `api/CreditCard/GetFSAuthenticationKey`,
            body: {
                CompanyCode: props.code
            }
        })
            .then((res: any) => {
                setLoading(false)
                setAuthKeyData(res.data)
                if (props.payment && value) {
                    openModal()
                } else {
                    setShow(true)
                }
            })
            .catch((e) => {
                setLoading(false)
            })
    }

    return <>
        <Modal show={show} onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="card-view">
                    <div className="col-12 d-flex">
                        <div className="col-6">
                            <Label title="Amount" />
                            <div>
                                <input type="text" className="form-control input" defaultValue={downPayment} value={finalAmount} onChange={(e) => setFinalAmount(e.target.value)} onKeyPress={(e) =>
                                    HelperService.allowOnlyNumericValue(e)
                                } onBlur={(e) => HelperService.formateUptoTwoDecimal(e)} readOnly={!isAmtEditable} />
                            </div>
                        </div>
                        {
                            feeData?.transactionFeeEnabled &&

                            (!feeData?.checkSalesAmtMin || feeData?.checkSalesAmtMin && Number(finalAmount) > Number(feeData?.salesAmountLowerCeiling)) &&
                            <div className="col-5 ms-3">
                                <Label title={feeData?.transactionFeeLabel} />
                                <div className="fee">{((feeData?.transactionFeePerc / 100) * finalAmount).toFixed(2)}</div>
                            </div>
                        }
                    </div>
                    {
                        savedCardsData.length > 0 && savedCardsData.map((res) => {
                            return (
                                <>
                                    {
                                        res.cardType == "VISA" &&
                                        <>
                                            <div className="d-flex">
                                                <input type="radio" className="payment-radio" checked={selectedCard == res.sequence ? true : false} onChange={() => setSelectedCard(res.sequence)} />
                                                <div className="credit-card visa selectable">
                                                    <div className="credit-card-last4">
                                                        {res.last4digits}
                                                    </div>
                                                    <div className="credit-card-expiry">
                                                        {res.cardExpiryMonth}/{res.cardExpiryYear}
                                                    </div>
                                                    <div className="card-holder-name">{res.cardHolderName}</div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                    {
                                        res.cardType == 'MC' &&
                                        <>
                                            <div className="d-flex">
                                                <input type="radio" className="payment-radio" checked={selectedCard == res.sequence ? true : false} onChange={() => setSelectedCard(res.sequence)} />
                                                <div className="credit-card mastercard selectable">
                                                    <div className="credit-card-last4">
                                                        {res.last4digits}
                                                    </div>
                                                    <div className="credit-card-expiry">
                                                        {res.cardExpiryMonth}/{res.cardExpiryYear}
                                                    </div>
                                                    <div className="card-holder-name">{res.cardHolderName}</div>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </>
                            )
                        })
                    }
                    <div className="d-flex">
                        <input type="radio" className="payment-radio" checked={selectedCard == 'NEW_CARD' ? true : false} onChange={() => setSelectedCard('NEW_CARD')} />
                        <div className="add-credit-card">
                            <PlusSquare className="me-2" /> Add New Card
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                {
                    finalAmount >= 1 &&
                    <Button label={selectedCard == 'NEW_CARD' ? `Add & Pay $${(Number(finalAmount) + Number(total_amount)).toFixed(2)}` : `Pay $${(Number(finalAmount) + Number(total_amount)).toFixed(2)}`} size='medium' onClick={() => {
                        if (selectedCard == 'NEW_CARD') {
                            setShow(false)
                            openModal()
                        } else {
                            setShow(false)
                            onMakePayment()
                        }
                    }} />
                }

            </Modal.Footer>
        </Modal>
        <Loader show={isLoading} />
        {
            !props.payment &&
            <div className='page-content-wraper general-Info'>
                <Row>
                    <Col md={12} id="wideCol">
                        <Card className="card-style form-style" style={{ marginBottom: 50 }}>
                            {
                                <Card.Body className="border-bottom border-light p-0">
                                    <Row>
                                        <Col md={2} className="text-center payment-box-view p-4">
                                            <p className="mb-0 font-w-medium font-14">Invoice Total</p>
                                            <div className="font-14 payment-reference-amount">{invoiceData?.invTotalAmt ? '$' + HelperService.getCurrencyFormatter(invoiceData?.invTotalAmt) : '-'}</div>
                                        </Col>
                                        <Col md={2} className="text-center payment-box-view p-4">
                                            <p className="mb-0 font-w-medium font-14">Deposit</p>
                                            <div className="font-14 payment-reference-amount">{invoiceData?.depositAmt ? '$' + HelperService.getCurrencyFormatter(invoiceData?.depositAmt) : '-'}</div>
                                            <div className="font-8">{invoiceData?.depositRef}</div>
                                        </Col>
                                        <Col md={2} className="text-center payment-box-view p-4">
                                            <p className="mb-0 font-w-medium font-14">Remaining $</p>
                                            <div className="font-14 payment-reference-amount">{"$" + HelperService.getCurrencyFormatter((Number(invoiceData?.invTotalAmt) - Number(invoiceData?.depositAmt)))}</div>
                                        </Col>
                                        <Col md={2} className="text-center payment-box-view p-4">
                                            <p className="mb-0 font-w-medium font-14">Payment 1</p>
                                            {
                                                invoiceData?.paymentAmt1 ?
                                                    <>
                                                        <div className="font-14 payment-reference-amount">{invoiceData?.paymentAmt1 ? '$' + HelperService.getCurrencyFormatter(invoiceData?.paymentAmt1) : '-'}</div>
                                                        <div className="font-8 mt-1">{invoiceData?.paymentRefNum1}</div>
                                                    </>
                                                    : null
                                                    // <div className="mt-3">
                                                    //     {
                                                    //         downPayment > 0 ? <Button label={`Pay $ ${HelperService.getCurrencyFormatter(downPayment)}`} size='medium' onClick={() => { getSavedCards(); setFinalAmount(downPayment); getAuthorizationKey(); }} /> : '-'
                                                    //     }
                                                    // </div>
                                            }
                                        </Col>
                                        <Col md={2} className="text-center payment-box-view p-4">
                                            <p className="mb-0 font-w-medium font-14">Payment 2</p>
                                            {
                                                invoiceData?.paymentAmt2 ?
                                                    <>
                                                        <div className="font-14 payment-reference-amount">{invoiceData?.paymentAmt2 ? '$' + HelperService.getCurrencyFormatter(invoiceData?.paymentAmt2) : '-'}</div>
                                                        <div className="font-8 mt-1">{invoiceData?.paymentRefNum2}</div>
                                                    </>
                                                    : null
                                                    // <div className="mt-3">
                                                    //     {
                                                    //         (downPayment > 0 && invoiceData?.paymentAmt1) ? <Button label={`Pay $ ${invoiceData?.amountDue ? HelperService.getCurrencyFormatter(invoiceData?.amountDue) : HelperService.getCurrencyFormatter(Number(invoiceData?.invTotalAmt) - Number(invoiceData?.paymentAmt1))}`} size='medium' onClick={() => { getSavedCards(); setFinalAmount(downPayment); getAuthorizationKey(); }} /> : '-'
                                                    //     }
                                                    // </div>
                                            }
                                        </Col>
                                        <Col md={2} className="text-center payment-box-view p-4">
                                            <p className="mb-0 font-w-medium font-14">Balance Due</p>
                                            <div className="font-14 payment-reference-amount" style={{ color: '#F55943' }}>{downPayment ? '$' + HelperService.getCurrencyFormatter(downPayment) : '$ 0.00'}</div>
                                        </Col>
                                        {/* {
                                         props?.data?.callInfo?.amountDue ?
                                             <Col md={4} className="text-center payment-box-view p-4">
                                                 <div className="mt-3">
                                                     <Button label={`Pay $ ${props?.data?.callInfo?.amountDue}`} size='medium' />
                                                 </div>
                                             </Col> : null
                                     } */}
                                    </Row>
                                    {
                                        !props.payment &&
                                        <div className="p-3">
                                            <Grid
                                                headers={headers}
                                                rows={rows}
                                                ShowLoader={false}
                                                errorMessage={'No Payment History Available'} />
                                        </div>
                                    }
                                </Card.Body>
                            }
                        </Card>
                    </Col>
                </Row>
            </div>
        }

    </>;
};

export default InvoiceDetailPaymentList;


